module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-sl.9da2d871.png";